export const websiteTheme = {
    headlines: {
        fontFamily: 'sofia-pro',
        xxxxl: {
            fontSize: '64px',
            lineHeight: '64px',
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'bold',
            },
            bold: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'bold',
            },
        },
        xxxl: {
            fontSize: '46px',
            lineHeight: 'normal',
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'bold',
            },
            bold: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'bold',
            },
        },
        xl: {
            fontSize: '28px',
            lineHeight: 'normal',
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'bold',
            },
            bold: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'bold',
            },
        },
        lg: {
            fontSize: '18px',
            lineHeight: '1.5',
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'normal',
            },
            bold: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'normal',
            },
        },
        md: {
            fontSize: '16px',
            lineHeight: '1.69',
            contrastInvertBold: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'bold',
            },
            bold: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'bold',
            },
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'normal',
            },
            regular: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'normal',
            },
        },
        sm: {
            fontSize: '14px',
            lineHeight: '1.93',
            bold: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'bold',
            },
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'normal',
            },
        },
    },
    brandText: {
        fontFamily: 'Inter',
        lg: {
            fontSize: '18px',
            lineHeight: '1.5',
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'normal',
            },
            bold: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'normal',
            },
            regular: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'normal',
            },
        },
        sm: {
            fontSize: '14px',
            lineHeight: '1.93',
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'normal',
            },
            bold: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'bold',
            },
            accentCoral: {
                color: (props) => props.theme.palette.brand.accentCoral,
                fontWeight: 'bold',
            },
        },
        xs: {
            fontSize: '12px',
            lineHeight: '2.25',
            contrastInvert: {
                color: (props) => props.theme.palette.contrastInvert,
                fontWeight: 'normal',
            },
            regular: {
                color: (props) => props.theme.palette.brand.darkBlue,
                fontWeight: 'normal',
            },
        },
    },
};
//# sourceMappingURL=websiteTheme.js.map